import { EASYPAY_PAYMENT_TYPES, PAYMENT_METHODS_STATUSES } from 'constants/index';

export type EasyPayStatusResult =
  | { kind: 'paid' }
  | { kind: 'pending'; label: string }
  | { kind: 'button' };

const PENDING_LABELS: Record<string, string> = {
  [EASYPAY_PAYMENT_TYPES.ACH]: 'PENDING ACH',
  [EASYPAY_PAYMENT_TYPES.FLOORING]: 'FLOORED',
  [EASYPAY_PAYMENT_TYPES.Other]: 'PENDING',
  [EASYPAY_PAYMENT_TYPES.ON_ACCOUNT]: 'PENDING',
};

export const getEasyPayStatus = (vehicle: any): EasyPayStatusResult => {
  const { payment_status, payment_type, money_flow, vehicle_price, buy_fee, additional_fees } = vehicle;

  const totalPaid = (money_flow ?? []).reduce((sum: number, p: any) => sum + Number(p.amount), 0);
  const totalPrice =
    (vehicle_price ?? 0) +
    (buy_fee?.processing_fee ?? 0) +
    (buy_fee?.transportation_fee ?? 0) +
    (additional_fees ?? []).reduce((sum: number, f: any) => sum + Number(f.fee_amount), 0);

  if (payment_status === PAYMENT_METHODS_STATUSES.APPROVED) {
    if (totalPaid >= totalPrice) {
      return { kind: 'paid' };
    }
    if (payment_type) {
      return { kind: 'pending', label: PENDING_LABELS[payment_type] ?? 'PENDING' };
    }
  }

  if (payment_type && payment_status === PAYMENT_METHODS_STATUSES.PENDING) {
    return { kind: 'pending', label: 'AWAITING ADMIN APPROVAL' };
  }

  return { kind: 'button' };
};
